import { render, staticRenderFns } from "./Daily.vue?vue&type=template&id=6705bfb6"
import script from "./Daily.vue?vue&type=script&lang=js"
export * from "./Daily.vue?vue&type=script&lang=js"
import style0 from "./Daily.vue?vue&type=style&index=0&id=6705bfb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconCalendarStar: require('/app/components/icons/IconCalendarStar.vue').default})
